<!--
 * @Author: WLL
 * @Date: 2020-03-21 18:26:26
 * @LastEditors: WLL
 * @LastEditTime: 2020-03-22 10:45:03
 * @Description: file content
 -->
<template>
  <SjDropdown
    placement="top"
    trigger="click"
    :arrowVisible="false"
    class="sj-timePopSelector"
    :closeOnClick="false"
    @show="dropdownShow = true"
    @hide="dropdownShow = false"
  >
    <div
      slot="reference"
      :class="[
        'sj-timePopSelector-wrapper',
        {
          dropdownShow
        }
      ]"
    >
      <SjIcon
        iconClass="comicon_time"
        hoverBackgroundColor="transparent"
        :stopEvent="false"
      ></SjIcon>
      <EditText
        v-model="value[0]"
        :formatter="textFormatter"
        :valueFormatter="hourFormatter"
        class="sj-timePopSelector-item"
      ></EditText>
      <template v-if="precision !== 'hour'">
        <span>:</span>
        <EditText
          v-model="value[1]"
          :formatter="textFormatter"
          :valueFormatter="minuteFormatter"
          class="sj-timePopSelector-item"
        ></EditText>
      </template>
      <template v-if="precision === 'second'">
        <span>:</span>
        <EditText
          v-model="value[2]"
          :formatter="textFormatter"
          :valueFormatter="minuteFormatter"
          class="sj-timePopSelector-item"
        ></EditText>
      </template>
    </div>
    <div slot="dropdown" class="sj-timePopSelector-dropdown">
      <TimePanel
        :value="value"
        :precision="precision"
        v-if="dropdownShow"
        @input="$emit('input', $event)"
        :height="136"
        :itemHeight="22"
      ></TimePanel>
    </div>
  </SjDropdown>
</template>

<script>
import EditText from "./editText";
import TimePanel from "../panels/time";
export default {
  name: "TimePopSelector",
  components: {
    EditText,
    TimePanel
  },
  props: {
    value: {
      type: Array,
      default() {
        return [0, 0, 0];
      }
    },
    precision: {
      type: String,
      default: "second",
      validator(v) {
        return ["second", "minute", "hour"].indexOf(v) !== -1;
      }
    }
  },
  data() {
    return {
      dropdownShow: false
    };
  },
  methods: {
    textFormatter(val) {
      return `0${val}`.slice(-2);
    },
    hourFormatter(val, oldVal) {
      const newVal = parseInt(val);
      return !isNaN(newVal) && newVal >= 0 && newVal < 24 ? newVal : oldVal;
    },
    minuteFormatter(val, oldVal) {
      const newVal = parseInt(val);
      return !isNaN(newVal) && newVal >= 0 && newVal < 60 ? newVal : oldVal;
    }
  }
};
</script>

<style lang="less" scoped>
.sj-timePopSelector {
  /deep/.sj-dropdown {
    border: 0;
  }
  .sj-timePopSelector-wrapper {
    display: flex;
    align-items: center;
    .text("caption", "dark");
    &.dropdownShow {
      color: @color-highlight;

      /deep/.sj-icon {
        color: @color-highlight;
      }
    }
    .sj-timePopSelector-item {
      width: 24px;
      text-align: center;
      justify-content: center;
    }
  }
  .sj-timePopSelector-dropdown {
    width: 128px;
    border-radius: 4px;
    overflow: hidden;

    /deep/.sj-panel-time {
      .sj-panel-time-item {
        background-color: @color-productlight;
        margin-left: 1px !important;
        &:first-child {
          margin-left: 0 !important;
        }

        .sj-scrollBar-item {
          margin: 0 4px;
          &.selected {
            background-color: @color-antibg;
          }
        }
      }
    }
  }
}
</style>
